export default function (action) {
  let lastCallPromise = null
  let lastCallTime = null
  let lastPathname = null
  let lastArgs = []

  return function() {
    const now = Date.now()
    const { pathname } = window.location
    const args = [...arguments]

    return (dispatch) => {
      if (
        lastCallPromise &&
        now - lastCallTime < 3000 &&
        lastPathname === pathname &&
        lastArgs.every((value, index) => args[index] === value)
      ) {
        return lastCallPromise;
      }

      lastArgs = args
      lastCallTime = now
      lastPathname = pathname
      lastCallPromise = action.apply(null, args)(dispatch)

      return lastCallPromise
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/mergeRequestsWrapper.js